import { GetInvoiceVersionsResponse } from '../../../../../types/Invoicing/Invoices/InvoiceVersion/InvoiceVersionTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  InvoiceVersionListApiConfig,
} from '../../../apiList'

const getInvoiceVersion = async (
  invoiceId: number,
): Promise<GetInvoiceVersionsResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceVersionListApiConfig.getInvoiceVersions,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
    data: {
      invoiceId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const invoiceVersionApi = {
  getInvoiceVersion,
}

export default invoiceVersionApi
